<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div>
        <a-icon type="wallet" class="margin-right-small" />
        {{ datasource.jenis=='draft' ? 'Edit Manifest PP/PD Turunan' : 'Manifest PP/PD Turunan' }}
        <div class="no_trans_tittle">
          #{{ datasource.hdr.no_rekap_ap }}
        </div>
      </div>
      <span></span>
    </div>
    <div class="wrapper-body">
      <a-row :gutter="5" type="flex">
        <a-col :xs="{ span: 24 }" :lg="{ span: collapse.left }" class="contentleft">
          <a-collapse activeKey="1">
            <a-collapse-panel key="1" :show-arrow="false" disabled>
              <a-row slot="header" :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 5 }" class="align-middle">
                  Period
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 19 }">
                  <a-select
                    placeholder="Choose Transaction Type"
                    v-model="filter.period"
                    :disabled="true"
                    @change="fetchData()"
                    class="width-full"
                  >
                    <a-select-option
                      v-for="item in list_periode"
                      :key="item.key">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table bordered :columns="columns_resume" :data-source="datasource.resume" size="small" 
                :rowKey="(record) => { return record.key; }" 
                  :pagination="false"
                  :loading="table.loading"
                  class="table-resume"
                >
                  <template slot="plafon" slot-scope="item">
                    <div class="width-full">
                      <b v-if="item.children">{{ item.name }}</b>
                      <b v-else>{{ item.name }}</b>
                      <div class="width-full">
                        <CurrencyJustified
                          :currencyValue="'IDR'"
                          :valueNumber="item.value"
                        />
                      </div>
                    </div>
                  </template>
                  <template slot="footer">
                    <div class="m-display-flex space-between align-middle cl_footer_man">
                      <div class="cl_footer_man-gt"><b>Grand Total</b></div>
                      <div class="cl_footer_man-val"><CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="total_liabilities_plafon"
                      />
                      </div>
                    </div>
                  </template>
                </a-table>
              </a-config-provider>

              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table bordered :columns="columns_kemampuan_bayar" :data-source="data_kemampuan_bayar" size="small" 
                :rowKey="(record) => { return record.label; }" 
                  :pagination="false"
                  :loading="table.loading"
                  class="table-resume margin-top"
                >
                  <template slot="pay" slot-scope="item">
                    <div class="width-full">
                      <div class="m-width-full m-display-flex space-between align-middle">
                        <div><b>{{ item.label }}</b></div>
                        <a-button-group>
                          <a-button :type="datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] ? 'primary' : 'default'" class="align-middle" 
                            @click="editLiabilities(item)" 
                            :disabled="(!datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] && datasource.kemampuan_bayar_edit_sts.isstatus) ||
                              disabledEditLiabilities" 
                            :loading="datasource.kemampuan_bayar_edit_sts.isloading && datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()]"
                            :icon="datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] ? 'save' : 'edit'" size="small"></a-button>
                          <a-button 
                            v-if="datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()]"
                            :disabled="datasource.kemampuan_bayar_edit_sts.isloading"
                            :type="'danger'" class="align-middle" @click="canceleditLiabilities(item)" icon="close" size="small"></a-button>
                        </a-button-group>
                      </div>
                      <div class="width-full margin-top">
                        <a-input-number
                          v-if="datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()]"
                          :min="0"
                          :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                          :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                          v-model="datasource.kemampuan_bayar[item.label.replace(' ','_').toLowerCase()]"
                          class="width-full w-full-currency-flex m-text-align-right"
                          @keydown="(e)=>{onlyNumber(e)}"
                        ></a-input-number>
                        <CurrencyJustified
                          v-else
                          :currencyValue="'IDR'"
                          :valueNumber="datasource.kemampuan_bayar[item.label.replace(' ','_').toLowerCase()]"
                        />
                      </div>
                    </div>
                  </template>

                  <template slot="footer">
                    <div class="m-display-flex space-between align-middle cl_footer_man">
                      <div class="cl_footer_man-gt"><b>Grand Total</b></div>
                      <div class="cl_footer_man-val"><CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="total_liabilities_pay"
                      />
                      </div>
                    </div>
                  </template>
                </a-table>
              </a-config-provider>

              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table bordered :columns="columns_rencana_bayar" :data-source="data_rencana_bayar" size="small" 
                :rowKey="(record, index) => { return index; }" 
                  :pagination="false"
                  :loading="table.loading"
                  class="table-resume margin-top"
                >
                  <template slot="pay" slot-scope="item">
                    <div class="width-full">
                      <b>{{ item.label }}</b>
                      <div class="width-full">
                        <CurrencyJustified
                          :currencyValue="'IDR'"
                          :valueNumber="item.value"
                        />
                      </div>
                    </div>
                  </template>

                  <template slot="footer">
                    <div class="m-display-flex space-between align-middle cl_footer_man">
                      <div class="cl_footer_man-gt"><b>Grand Total</b></div>
                      <div class="cl_footer_man-val"><CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="total_rencana_bayar"
                      />
                      </div>
                    </div>
                  </template>
                </a-table>
              </a-config-provider>

              <div class="m-display-flex space-between align-middle margin-top cl_footer_man-2">
                <div class="m-display-flex cl_footer_man-gt-2">
                  <b>Selisih</b>
                  &nbsp;
                  <a-tooltip
                    class="m-tooltip-inner"
                    placement="top"
                    title="(Kemampuan Bayar - Rencana Pengeluaran)"
                  >
                    <span class="m-text-ellipse"><sup><a-icon type="info-circle"/></sup></span>
                  </a-tooltip>
                </div>
                <div class="cl_footer_man-val">
                  <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="total_deviation"
                  />
                </div>
              </div>

              <div class="m-display-flex space-between align-middle margin-top cl_footer_man-2">
                <div class="cl_footer_man-gt-2"><b>PP/PD Non Plafon</b></div>
                <div class="cl_footer_man-val"><CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="datasource.pppd_tanpa_plafon"
                />
                </div>
              </div>

            </a-collapse-panel>
          </a-collapse>
          
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: collapse.center }">
          <a-card class="nopad">
            <a-row :gutter="5" type="flex" style="height: 100%;flex-direction: column;align-items: stretch;">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }"  style="padding:0px!important">
                <a-card class="addpadd">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
                      <a-input-search v-model="search" placeholder="Quick Search" />
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
                      <a-button
                        :class="getScreen ? 'margin-top' : ''"
                        block
                        :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                        @click="handleshowMore"
                        >{{
                          advancedsearch == "display:none" ? "More" : "Less"
                        }}</a-button
                      >
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }">
                      <a-button :type="collapse.iscollapse=='active' ? 'danger' : 'default'"  class="width-full margin-small-right" :icon="collapse.iscollapse=='active' ? 'shrink' : 'arrows-alt'"
                            @click="(e)=>{e.stopPropagation();handleCollapse()}"></a-button>
                    </a-col>
                  </a-row>
                  <a-row :style="advancedsearch" :gutter="16" class="margin-top">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <div class="m-form-item-wrapper">
                        <label>Transaction Type</label>
                        <a-select
                          placeholder="Choose Transaction Type"
                          v-model="filter.trans_type"
                          class="width-full"
                        >
                          <a-select-option :key="0" value="all">All Transaction Type</a-select-option>
                          <a-select-option
                            v-for="item in datasource.transtype"
                            :key="item"
                            >{{ item }}</a-select-option
                          >
                        </a-select>
                      </div>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <div class="m-form-item-wrapper">
                        <label>Directorate</label>
                        <a-select
                          placeholder="Choose Directorate"
                          v-model="filter.directorate"
                          class="width-full"
                        >
                          <a-select-option :key="0" value="all">All Directorate</a-select-option>
                          <a-select-option
                            v-for="item in datasource.directorate"
                            :key="item"
                            >{{ item }}</a-select-option
                          >
                        </a-select>
                      </div>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <div class="m-form-item-wrapper">
                        <label>Cost Center</label>
                        <a-select
                          show-search
                          placeholder="Choose Cost Center"
                          v-model="filter.cost_center"
                          class="width-full"
                        >
                          <a-select-option :key="0" value="all">All Cost Center</a-select-option>
                          <a-select-option
                            v-for="item in datasource.cost_center"
                            :key="item"
                            >{{ item }}</a-select-option
                          >
                        </a-select>
                      </div>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <div class="m-form-item-wrapper">
                        <label>End User</label>
                        <a-select
                          show-search
                          placeholder="Choose End User"
                          v-model="filter.enduser"
                          class="width-full"
                        >
                          <a-select-option :key="0" value="all">All End User</a-select-option>
                          <a-select-option
                            v-for="item in datasource.enduser"
                            :key="item"
                            >{{ item }}</a-select-option
                          >
                        </a-select>
                      </div>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <div class="m-form-item-wrapper">
                        <label>Create Date</label>
                        <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="filter.create_dt"
                          :format="getDefaultDateFormat" allowClear />
                      </div>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <div class="m-form-item-wrapper">
                        <label>Status</label>
                        <a-select
                          placeholder="Choose Status"
                          v-model="filter.sts"
                          class="width-full"
                        >
                          <a-select-option :key="0" value="all">All Status</a-select-option>
                          <a-select-option :key="1" value="1">Selected</a-select-option>
                          <a-select-option :key="2" value="0">Not Selected</a-select-option>
                        </a-select>
                      </div>
                    </a-col>
                  </a-row>
                </a-card>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }" style="flex:1;padding:0px!important">
                <a-card>
                  <a-config-provider :locale="getLocalConfigProvider()">
                    <a-table bordered :columns="columns" :data-source="_list" size="small" 
                      :pagination="pagination" 
                      :rowKey="(record, index) => { return index; }" 
                      :loading="table.loading || action.loading_save_postval"
                      :scroll="{ x: 1500, y: true }"
                    >
                      <template slot="no" slot-scope="text, data, index">
                        {{ index + 1 }}
                      </template>
                      <span slot="dt_tlc" slot-scope="item">
                        {{ moment(item.tgl_buat).format(getDefaultDateFormat) }} / {{ item.tlc }}
                      </span>
                      <span slot="notrans" slot-scope="item">
                        <div><b>{{item.type_plafon=='Operational' ? 'Directorate' : item.type_plafon}} | {{ jnsTransLabel(item.jenis_transaksi) }}</b></div>
                        <div><a @click="toManifest(item)"><b>{{ item.no_inv_ap_ad || item.no_trans }}</b></a></div>
                        <div>{{item.deskripsi || item.description}}</div>
                      </span>
                      <span slot="eval" slot-scope="item">
                        <CurrencyJustified
                          :currencyValue="'IDR'"
                          :valueNumber="item.value_kurs"
                        />
                      </span>
                      <span slot="val" slot-scope="item">
                        <CurrencyJustified
                          :currencyValue="item.currency"
                          :valueNumber="item.value"
                        />
                      </span>
                      <span slot="eidr" slot-scope="item">
                        <CurrencyJustified
                          :currencyValue="'IDR'"
                          :valueNumber="item.kurs_idr"
                        />
                      </span>
                      <span slot="balance_val" slot-scope="item">
                        <CurrencyJustified
                          :currencyValue="item.currency"
                          :valueNumber="item.sisa_trf_kurs"
                        />
                      </span>
                      <span slot="balance_eval" slot-scope="item">
                        <CurrencyJustified
                          :currencyValue="'IDR'"
                          :valueNumber="item.sisa_trf"
                        />
                      </span>
                      <span slot="sts" slot-scope="item">
                        <a-tag :color="item.status=='High' ? 'red' : (item.status=='Normal' ? 'green' : (item.status=='Direct' ? 'purple' : 'default'))" 
                          :class="item.status=='Low' ? 'width-full tag-defaults' : 'width-full'">{{ item.status ? (item.status=='Direct' ? 'Direct Allocated' : item.status) : '' }}</a-tag>
                      </span>
                      <span slot="post_exchange_val" slot-scope="item">
                        <CurrencyJustified
                          class="w-full-currency-flex"
                          :currencyValue="'IDR'"
                          :valueNumber="item.post_value_kurs"
                        />
                      </span>
                      <template slot="operation" slot-scope="text, item, index">
                        <span v-if="datasource.jenis!='draft'">{{ index+1 }}</span>
                        <a-checkbox
                          v-else
                          :value="item.check_sts"
                          :checked="item.check_sts==1"
                          :disabled="item.enable_directorate!='1' && !isKeuangan"
                          @change="(e)=> { savingPayment(item, e) }"
                        />
                      </template>
                      <span slot="transactionage" slot-scope="item">
                        {{ item.umur }}
                      </span>
                      <template slot="footer">
                        <a-row :gutter="0" >
                          <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                            <!-- <a-button type="primary" class="margin-small-right" icon="save"
                              :loading="action.loading_submit" @click="savetoplafon()">Submit to Plafon</a-button> -->
                          </a-col>
                          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                            <div style="display: flex;justify-content: end;">Total All Value :</div>
                            <div style="display: flex;justify-content: end;">Total Selected Value :</div>
                            <div style="display: flex;justify-content: end;">Total Unselected Value :</div>
                          </a-col>
                          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                            <CurrencyJustified
                              class="w-full-currency-flex"
                              :currencyValue="'IDR'"
                              :valueNumber="totalAllValue"
                            />
                            <CurrencyJustified
                              class="w-full-currency-flex"
                              :currencyValue="'IDR'"
                              :valueNumber="totalSelectedValue"
                            />
                            <CurrencyJustified
                              class="w-full-currency-flex"
                              :currencyValue="'IDR'"
                              :valueNumber="totalUnSelectedValue"
                            />
                          </a-col>
                        </a-row>
                      </template>
                    </a-table>
                  </a-config-provider>
                </a-card>
              </a-col>
            </a-row>
          </a-card>

          <a-card
            class="margin-top"
            :loading="table.loading"
            v-if="datasource.jenis.toLowerCase() === 'approve'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="2"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in datasource.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleSubmit"
                  :loading="table.loading_submit"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: collapse.right }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="datasource.hdr.status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="history" />
                  </a-button>
                </div>
              </div>
              <div v-if="table.loading">
                <div style="min-height: 150px;">
                  <a-spin :spinning="table.loading" tip="Loading..."></a-spin>
                </div>
              </div>
              <a-timeline v-else class="m-timeline">
                <a-timeline-item color="green" :loading="true">
                  <div class="m-timeline-title">Creator - {{ datasource.hdr.tlc_create }}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(datasource.hdr.create_dt).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="datasource.hdr.description"
                      >{{ datasource.hdr.description }}</span
                    >
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="(workflow, index) in datasource.workflow"
                  :key="index"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" /> History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in datasource.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal v-model="action.visible" :title="'Option Action Selected : '" :footer="false" @cancel="handleActionCancel" :maskClosable="false">
      <div class="m-width-full">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-button type="danger" class="m-width-full" @click="actionSelectedPost('Urgensi')" 
              :loading="action.loading_urgen" :disabled="action.loading_normal">Set to Urgent</a-button>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-button type="primary" class="m-width-full" @click="actionSelectedPost('Normal')" 
              :loading="action.loading_normal" :disabled="action.loading_urgen">Set to Normal</a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
moment.locale("id");

export default {
  name: "manifestAccountPayMonitoring",
  mixins: [GlobalMethod, CurrencyFormat],
  props: ['id'],
  components: {},
  data() {
    return {
      search: "",
      advancedsearch: "display:none",
      filter:{
        period: null,
        trans_type: 'all',
        directorate: 'all',
        enduser: 'all',
        sts: 'all',
        create_dt: [null,null],
        cost_center: 'all',
      },
      table:{
        loading: false,
        loading_submit: false
      },
      datasource:{
        jenis: "manifest",
        data: [],
        resume: [],
        kemampuan_bayar: [],
        kemampuan_bayar_edit_sts:{
          origin: 0,
          isstatus: false,
          isloading: false,
          pendanaan: false,
          penerimaan_proyek: false,
          saldo_bank: false
        },
        rencana_pengeluaran: [],
        workflow: [],
        aksi:[],
        hdr: [],
        transtype: [],
        directorate: [],
        enduser: [],
        history: [],
        all_count: 0,
        selected_count: 0,
        unselected_count: 0,
        pppd_tanpa_plafon: 0
      },
      action:{
        visible:false,
        edit_active: false,
        edit_active_origin: 0,
        loading_urgen: false,
        loading_normal: false,
        loading_save_postval: false,
        loading_submit: false
      },
      pagination: {
        pageSize: 20,
        size: "small",
      },
      collapse:{
        left: 5,
        center: 14,
        right: 5,
        iscollapse: 'nonactive'
      },
      visibleHistory: false,
      choosing_sts: null,
      choosing_value: null,
      choosing_max_value: null,
      choosing_posting: null,
      direktorat_user: null
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDateTimeFormat",
    ]),
    isrevisi(){
      return this.$route.meta ? this.$route.meta.revisi : false
    },
    list_periode(){
      return [
        {
          key: this.filter.period ? moment(this.filter.period, this.getStandartFormatDate).format("YYYY-MM") : '',
          label: this.filter.period ? moment(this.filter.period, this.getStandartFormatDate).locale("id").format('MMMM-YYYY') : ''
        }
      ]
    },
    columns() {
      const columns = [
          {
            title: "#",
            dataIndex: "operation",
            key: "operation",
            scopedSlots: { customRender: "operation" },
            width: '50px',
            align: "center",
            fixed: "left",
          },
          
          {
            title: "Balance Value (IDR)",
            key: "balance_eval",
            width: "150px",
            scopedSlots: { customRender: "balance_eval" },
            sorter: (a, b) => a.sisa_trf_kurs - b.sisa_trf_kurs,
          },
          
          {
            title: "Value",
            key: "eval",
            width: "150px",
            scopedSlots: { customRender: "eval" },
            sorter: (a, b) => a.value_kurs - b.value_kurs,
          },
          
          {
            title: "Type Plafon | No Trans. | Desc.",
            key: "notrans",
            align: "left",
            width: "250px",
            scopedSlots: { customRender: "notrans" },
            sorter: (a, b) => ((a.type_plafon=='Operational' ? 'Directorate' : a.type_plafon)+this.jnsTransLabel(a.jenis_transaksi)+a.no_inv_ap_ad+a.deskripsi).localeCompare(
              (b.type_plafon=='Operational' ? 'Directorate' : b.type_plafon)+this.jnsTransLabel(b.jenis_transaksi)+b.no_inv_ap_ad+b.deskripsi
            ),
          },
          {
            title: "Direktorat",
            key: "directorat",
            dataIndex: "direktorat",
            align: "left",
            width: "150px",
            sorter: (a, b) => (a.direktorat?a.direktorat:'').localeCompare(b.direktorat?b.direktorat:''),
          },
          {
            title: "Create Date / TLC",
            key: "dt_tlc",
            align: "center",
            width: "150px",
            scopedSlots: { customRender: "dt_tlc" },
            sorter: (a, b) => (moment(a.tgl_buat).format(this.getDefaultDateFormat)+a.tlc).localeCompare(
              moment(b.tgl_buat).format(this.getDefaultDateFormat)+b.tlc
            ),
          },
          {
            title: "End User",
            key: "end_user",
            dataIndex: "endusr_supp",
            align: "left",
            width: "200px",
            sorter: (a, b) => a.nama_supplier.localeCompare(b.nama_supplier),
          },
          {
            title: "Trans. Age",
            key: "transactionage",
            align: "left",
            scopedSlots: { customRender: "transactionage" },
            width: "120px",
            sorter: (a, b) => a.umur.localeCompare(b.umur),
          },
          {
            title: "Currency",
            key: "cur",
            dataIndex: "currency",
            align: "center",
            width: "75px",
            sorter: (a, b) => a.mata_uang.localeCompare(b.mata_uang),
          },
          {
            title: "Exchange (IDR)",
            key: "eidr",
            width: "150px",
            scopedSlots: { customRender: "eidr" },
            sorter: (a, b) => a.kurs - b.kurs,
          },
          {
            title: "Value",
            key: "val",
            width: "150px",
            scopedSlots: { customRender: "val" },
            sorter: (a, b) => a.value - b.value,
          },      
          {
            title: "Balance Value",
            key: "balance_val",
            width: "150px",
            scopedSlots: { customRender: "balance_val" },
            sorter: (a, b) => a.sisa_trf - b.sisa_trf,
          },
        ];
      return columns;
    },
    columns_resume(){
      const columns = [
          {
            title: "Plafon PP/PD Turunan",
            key: "plafon",
            scopedSlots: { customRender: "plafon" },
          },
        ];
      return columns;
    },
    _list() {
      let output = this.datasource.data;

      if(this.filter.trans_type!='all'){
        output = output.filter(
          (obj) => (obj.jenis_transaksi && obj.jenis_transaksi.toLowerCase() == this.filter.trans_type.toLowerCase())
        )
      }

      if(this.filter.directorate!='all'){
        output = output.filter(
          (obj) => (obj.direktorat && obj.direktorat.toLowerCase() == this.filter.directorate.toLowerCase())
        )
      }

      if(this.filter.enduser!='all'){
        output = output.filter(
          (obj) => (obj.nama_supplier && obj.nama_supplier.toLowerCase() == this.filter.enduser.toLowerCase())
        )
      }

      if(this.filter.sts!='all'){
        output = output.filter(
          (obj) => ((obj.check_sts ? 'select' : 'notselect') == (this.filter.sts=='1' ? 'select' : 'notselect'))
        )
      }

      if(this.filter.create_dt[0] && this.filter.create_dt[1]){
        output = output.filter(
          (obj) => (moment(obj.create_dt,'YYYY-MM-DD').format(this.getStandartFormatDate) >= this.filter.create_dt[0].format(this.getStandartFormatDate) &&
            moment(obj.create_dt,'YYYY-MM-DD').format(this.getStandartFormatDate) <= this.filter.create_dt[1].format(this.getStandartFormatDate))
        )
      }

      if(this.filter.cost_center!='all'){
        output = output.filter(
          (obj) => (obj.cost_center_kode && obj.cost_center_kode.toLowerCase() == this.filter.cost_center.toLowerCase())
        )
      }

      if(this.search)
        output = output.filter(
          (obj) =>
            (obj.jenis_transaksi && obj.jenis_transaksi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.direktorat && obj.direktorat.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.no_inv_ap_ad && obj.no_inv_ap_ad.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.create_dt && moment(obj.create_dt).format(this.getStandartFormatDate).toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.tlc && obj.tlc.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.deskripsi && obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.nama_supplier && obj.nama_supplier.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.currency && obj.currency.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        );
      return output;
    },
    columns_kemampuan_bayar(){
      const columns = [
          {
            title: "Kemampuan Bayar",
            key: "pay",
            scopedSlots: { customRender: "pay" },
          },
        ];
      return columns;
    },
    columns_rencana_bayar(){
      const columns = [
          {
            title: "Rencana Pengeluaran",
            key: "pay",
            scopedSlots: { customRender: "pay" },
          },
        ];
      return columns;
    },
    data_kemampuan_bayar(){
      let result = [];
      let lbl = "";

      for (const prop in this.datasource.kemampuan_bayar) {
        if(prop == 'saldo_bank'){
          lbl = 'Saldo Bank'
        }else if(prop == 'penerimaan_proyek'){
          lbl = 'Penerimaan Proyek'
        }else if(prop == 'pendanaan'){
          lbl = 'Pendanaan'
        }

        result.push({
          label: lbl,
          sedit: false,
          value:  this.datasource.kemampuan_bayar[prop]
        })
      }
      return result;
    },
    data_rencana_bayar(){
      let result = [];
      let lbl = "";

      for (const prop in this.datasource.rencana_pengeluaran) {
        if(prop == 'kewajiban'){
          lbl = 'Kewajiban'
        }else if(prop == 'rencana_belanja'){
          lbl = 'Rencana Belanja'
        }else if(prop == 'sisa_pp_pd'){
          lbl = 'Sisa PP PD'
        }else if(prop == 'trans_pp_pd'){
          lbl = 'Trans. PP PD'
        }

        result.push({
          label: lbl,
          value:  this.datasource.rencana_pengeluaran[prop]
        })
      }
      return result;
    },
    total_liabilities_plafon(){
      let result = 0;
      this.datasource.resume.forEach(element => {
        result += element.value;
      });
      return result;
    },
    total_liabilities_pay(){
      let result = 0;
      for (const prop in this.datasource.kemampuan_bayar) {
        result += Number(this.datasource.kemampuan_bayar[prop]);
      }
      return result;
    },
    total_rencana_bayar(){
      let result = 0;
      for (const prop in this.datasource.rencana_pengeluaran) {
        result += Number(this.datasource.rencana_pengeluaran[prop]);
      }
      return result;
    },
    total_deviation(){
      return this.total_liabilities_pay - this.total_rencana_bayar
    },
    disabledEditLiabilities(){
      return this.moment(this.filter.period)<=this.moment().subtract(1, 'month')
    },
    isKeuangan(){
      return ['Keuangan', 'Financial Control'].includes(this.getAuth.divisi[0])
    },
    totalAllValue() {
      const dtl = this.datasource
        && this.datasource.data
        && Array.isArray(this.datasource.data)
        ? this._list
        : []
      console.log(dtl)
      return dtl.reduce((total, item) => {
        return total + Number(item.post_value_kurs || 0)
      }, 0)
    },
    totalSelectedValue(){
      const dtl = this.datasource
        && this.datasource.data
        && Array.isArray(this.datasource.data)
        ? this._list
        : []
      
      return dtl.reduce((total, item) => {
        if(item.check_sts == 1){
          return total + Number(item.post_value_kurs || 0)
        }
        return total;
      }, 0)
    },
    totalUnSelectedValue(){
      const dtl = this.datasource
        && this.datasource.data
        && Array.isArray(this.datasource.data)
        ? this._list
        : []
      
      return dtl.reduce((total, item) => {
        if(item.check_sts == 0){
          return total + Number(item.post_value_kurs || 0)
        }
        return total;
      }, 0)
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    this.$store.dispatch("SHOWHIDE_SIDEBAR", true);
    this.fetchData()
  },
  beforeDestroy() {
    this.$store.dispatch("SHOWHIDE_SIDEBAR", false);
  },
  methods: {
    moment,
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    async fetchData() {
      this.table.loading = true;
      this.resetFilter();
      this.handleshowMore();

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "monitoring_pppd_turunan/" + (this.isrevisi ? 'manifest_edit' : 'manifest'),
        params: {
          mon_pppd_balance_id: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.table.loading = false;
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
            proses.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            this.datasource.jenis = response[0].data.jenis;
            let temp = response[0] ? response[0].data.dtl : [];
            temp.forEach(element => {
              element['vedit'] = false
            });
            this.datasource.data = temp
            this.filter.period = response[0] ? moment(response[0].data.periode,this.getStandartFormatDate).format('YYYY-MM') : null;
            this.datasource.hdr = response[0] ? response[0].data.hdr[0] : 0;
            this.datasource.resume = response[0] ? response[0].data.resume : [];
            this.datasource.kemampuan_bayar = response[0] ? response[0].data.kemampuan_bayar[0] : [];
            this.datasource.rencana_pengeluaran = response[0] ? response[0].data.rencana_pengeluaran[0] : [];
            this.datasource.all_count = response[0] ? response[0].data.all_count : 0;
            this.datasource.selected_count = response[0] ? response[0].data.selected_count : 0;
            this.datasource.unselected_count = response[0] ? response[0].data.unselected_count : 0;
            this.datasource.workflow = response[0] ? response[0].data.worlflow : 0;
            this.datasource.aksi = response[0] ? response[0].data.aksi : 0;
            this.datasource.history = response[0] ? response[0].data.notif : [];
            this.datasource.pppd_tanpa_plafon = response[0] ? response[0].data.pppd_tanpa_plafon : 0;

            this.direktorat_user = response[0] ? response[0].data.direktorat : null;
            if(this.direktorat_user){
              this.filter.directorate = this.direktorat_user
            }

            this.datasource.transtype = _.uniq(_.map(this.datasource.data,  item => item.jenis_transaksi ? this.jnsTransLabel(item.jenis_transaksi) : ''));
            this.datasource.directorate = _.uniq(_.map(this.datasource.resume[0].children, "name"))
            this.datasource.enduser = _.uniq(_.map(this.datasource.data, "nama_supplier"));
            this.datasource.cost_center = _.uniq(_.map(this.datasource.data, "cost_center_kode"));

            this.table.loading = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleCheck(item, event){
      this.action.visible = true
    },
    async actionSelected(item){
      this.datasource.data[_.findIndex(this.datasource.data, (e) => {
          return e.id == item.id;
        }, 0)].vedit = !item.vedit;
      this.action.edit_active_origin = item.post_value_kurs
      this.action.edit_active = true
      this.$nextTick(function () {
        const el = this.$refs[`inp_${item.id}`]
        el.focus();
      })
    },
    actionCancelSelected(item){
      const idx = _.findIndex(this.datasource.data, (e) => {
          return e.id == item.id;
        }, 0)
      this.datasource.data[idx].vedit = !item.vedit;
      this.datasource.data[idx].post_value_kurs = this.action.edit_active_origin;
      this.action.edit_active_origin = 0;
      this.action.edit_active = false
    },
    handleActionCancel(){
      this.action.visible = false
    },
    actionSelectedPost(params){
      if(params=='Urgensi'){
        this.action.loading_urgen = true;
      }else{
        this.action.loading_normal = true;
      }

      let data_item = [];
      this._list.forEach((element) => {
        if(element.check_sts==1) data_item.push({id:element.id, type:element.trans_type})
      })

      const payload = {
        data: data_item,
        status: params
      }
      this.asyncAxiosPost("pp-pd-monitoringzzzzz/set_status", "json", this.getAuth, payload)
      .then(() => {
        this.action.loading_urgen = false;
        this.action.loading_normal = false;
        this.action.visible = false;
        this.table.loading = false;
        this.$router.go();
      })
      .catch((err) => {
        console.log(err);
        this.table.loading = false;
      });
    },
    handleCollapse(){
      this.collapse.iscollapse = this.collapse.iscollapse=='active' ? 'nonactive' : 'active';
      this.collapse.left = this.collapse.iscollapse=='active' ? 0 : 5;
      this.collapse.center = this.collapse.iscollapse=='active' ? 24 : 14;
      this.collapse.right = this.collapse.iscollapse=='active' ? 0 : 5;
    },
    savingPayment(item, e){
      const that = this;
      that.choosing_posting = e.target.checked ? '1' : '0';
      that.choosing_sts = (item.status ? item.status : 'Normal');
      that.choosing_value = Number(item.value_kurs);
      that.choosing_max_value = Number(item.value_kurs);
      // this.$confirm({
      //   title: "Set data into periode "+that.filter.period+" with value below:",
      //   content: (h) => {
      //     // Render container div wrapper
      //     return h('div', { style: { marginTop: '15px' } }, [
      //       h('a-select', {
      //         props: {
      //           value: that.choosing_posting 
      //         },
      //         style: { width: '100%' },
      //         on: {
      //           change: (val) => {
      //             that.choosing_posting = val; 
      //           }
      //         }
      //       }, [
      //         h('a-select-option', { props: { value: '1' } }, [ 
      //           h('a-icon', {
      //             props: {
      //               type: 'check'
      //             },
      //             style: {
      //               color: '#52c41a',
      //               fontSize: '16px',
      //             }
      //           }),
      //           h('label', ' POSTING') ]),
      //         h('a-select-option', { props: { value: '0' } }, [ 
      //           h('a-icon', {
      //             props: {
      //               type: 'close'
      //             },
      //             style: {
      //               color: '#c41a1a',
      //               fontSize: '16px',
      //             }
      //           }),
      //           h('label', ' UNPOSTING') ])
      //       ]),
      //     ]);
      //   },
      //   okText: "Yes",
      //   cancelText: "No",
      //   onOk() {
          const idx = _.findIndex(that.datasource.data, (e) => {
              return e.id == item.id;
            }, 0)
          const dt = that.datasource.data[idx]

          if(that.choosing_posting=='1' && (dt.sisa_trf_kurs==0 || dt.sisa_trf_kurs==null)){
            that.displayMessageValue("error-other", "Post value must be more than 0!");
            return;
          }

          that.datasource.data[idx].vedit = true;
          that.action.loading_save_postval = true;
          that.action.edit_active = true;

          that.asyncAxiosPost("monitoring_pppd_turunan/bayar_edit", "json", that.getAuth, 
            {
              jenis_transaksi: dt.jenis_transaksi,
              id: dt.id,
              mon_pppd_balance_id: that.datasource.hdr.mon_pppd_balance_id,
              periode: that.filter.period,
              bayar: dt.sisa_trf_kurs,
              check_sts: that.choosing_posting
            }
          )
          .then((response) =>{
            that.datasource.resume = response ? response.resume : [];
            that.datasource.kemampuan_bayar = response ? response.kemampuan_bayar[0] : [];
            that.datasource.rencana_pengeluaran = response ? response.rencana_pengeluaran[0] : [];
            that.datasource.all_count = response ? response.all_count : 0;
            that.datasource.selected_count = response ? response.selected_count : 0;
            that.datasource.unselected_count = response ? response.unselected_count : 0;
            that.datasource.pppd_tanpa_plafon = response ? response.pppd_tanpa_plafon : 0;

            that.datasource.data[idx].vedit = false;
            that.datasource.data[idx].check_sts = Number(that.choosing_posting);
            // that.datasource.data[idx].status = that.choosing_posting=='0' ? null : that.choosing_sts;
            // that.datasource.data[idx].post_value_kurs = that.choosing_posting=='0' ? dt.value_kurs : that.choosing_value;
            that.action.edit_active_origin = 0;
            that.action.edit_active = false;
            that.action.loading_save_postval = false;
            that.displayMessageValue("success-other", response.message);
          })
          .catch((err) => {
            console.log(err);
            that.datasource.data[idx].vedit = false;
            that.action.edit_active_origin = 0;
            that.action.edit_active = false;
            that.action.loading_save_postval = false;
          });
      //   },
      //   onCancel() {

      //   },
      // })
    },
    validateNominal(e){
      if(!isNaN(parseInt(e.key))){
        if(Number(e.target.ariaValueNow+e.key)>Number(e.target.max)){
          e.preventDefault();
        }
      }
    },
    jnsTransLabel(val){
      let result = "";
      switch(val) {
			case 'kas_kecil':
				result = "KAS KECIL"
				break;
      case 'klaim_cc_pd':
				result = "KLAIM CC PD"
				break;
      case 'klaim_cc':
				result = "KLAIM CC"
				break;
      case 'klaim_cc_pp':
				result = "KLAIM CC PP"
				break;
      case 'klaimdirektur':
				result = "KLAIM DIREKTUR"
				break;
			default: result = val.toUpperCase(); break;
      }
      return result;
    },
    resetFilter(){
      this.advancedsearch = "none";
      this.filter.trans_type = 'all';
      this.filter.directorate = 'all';
      this.filter.enduser = 'all';
      this.filter.sts = 'all';
      this.filter.create_dt = [null,null];
      this.filter.cost_center = 'all';
    },
    saveLiabilities(){

    },
    editLiabilities(item){
      let sts = this.datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()];
      if(sts==false){
        this.datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] = !sts;
        
        this.datasource.kemampuan_bayar_edit_sts.origin = this.datasource.kemampuan_bayar[item.label.replace(' ','_').toLowerCase()];
        this.datasource.kemampuan_bayar_edit_sts.isstatus = true;
      }else{
        const that = this;
        // const lbloption = jns=='full' ? (e.target.checked ? 'POSTING' : 'UNPOSTING') : 'POSTING';
        this.$confirm({
          title: "Are you sure to save "+item.label+" to period "+that.filter.period+"?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            // const idx = _.findIndex(that.datasource.data, (e) => {
            //     return e.id == item.id;
            //   }, 0)
            // const dt = that.datasource.data[idx]
            // const check_sts = jns=='full' ? (e.target.checked ? ((jns=='full' ? 1 : (dt.post_value_kurs==dt.sisa_trf_kurs? 1 : 0))) : 0) : 1;

            // if(jns=='full'){
            //   that.datasource.data[idx].post_value_kurs = dt.sisa_trf_kurs
            // }
            // that.datasource.data[idx].vedit = true;
            // that.action.loading_save_postval = true;
            // that.action.edit_active = true;

            const urls = item.label.replace(' ','_').toLowerCase()
            let payload= {
              periode: that.filter.period
            }
            payload[urls] = that.datasource.kemampuan_bayar[item.label.replace(' ','_').toLowerCase()]

            that.datasource.kemampuan_bayar_edit_sts.isloading = true
            that.asyncAxiosPost("Account_pay_trans/"+urls, "json", that.getAuth, payload)
            .then((response) =>{
              that.datasource.kemampuan_bayar_edit_sts.origin = 0;
              that.datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] = false
              that.datasource.kemampuan_bayar_edit_sts.isstatus = false;
              that.datasource.kemampuan_bayar_edit_sts.isloading = false;
              that.displayMessageValue("success-other", response.message);
            })
            .catch((err) => {
              console.log(err);
            });
          },
          onCancel() {

          },
        })
      }

    },
    canceleditLiabilities(item){
      console.log(item, item.label.replace(' ','_').toLowerCase())
      this.datasource.kemampuan_bayar[item.label.replace(' ','_').toLowerCase()] = this.datasource.kemampuan_bayar_edit_sts.origin
      this.datasource.kemampuan_bayar_edit_sts.origin = 0
      this.datasource.kemampuan_bayar_edit_sts.isstatus = false;
      this.datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] =
        !this.datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()]
    },
    savetoplafon(){
      const that = this;

      this.$confirm({
      title: "Submitting into period "+that.filter.period+"?",
      content: "",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        const selectedData = _.filter(that.datasource.data, item => item.check_sts==1)
        if(selectedData==0){
          that.displayMessageValue("basic-warning", "No data selected!");
        }else{
          let fixeddata = [];
          selectedData.forEach(element => {
            fixeddata.push({
              jenis_transaksi: element.jenis_transaksi,
              id: element.id
            })
          });

          that.action.loading_submit = true
          that.asyncAxiosPost("monitoring_pppd_turunan/"+(that.datasource.jenis=='draft' ? 'revisi' : 'submit'), "json", that.getAuth, 
          that.datasource.jenis=='draft' ?
          {
            mon_pppd_balance_id: that.id
          } :
          {
            periode: that.filter.period,
            selected_item: fixeddata
          }
          )
          .then((response) =>{
            // that.datasource.kemampuan_bayar_edit_sts.origin = 0;
            // that.datasource.kemampuan_bayar_edit_sts[item.label.replace(' ','_').toLowerCase()] = false
            // that.datasource.kemampuan_bayar_edit_sts.isstatus = false;
            // that.datasource.kemampuan_bayar_edit_sts.isloading = false;
            that.action.loading_submit = false
            that.displayMessageValue("success-other", response.message);
            that.$router.go(0);
          })
          .catch((err) => {
            console.log(err);
          });
        }
      },
      onCancel() {},
      })
    },
    goto(item){
      this.$router.push({
        name: "manifestAccountpaymonitoringFC",
        params: { id: item.mon_pppd_balance_id },
      });
    },
    historyToggle(e){
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.table.loading_submit = true;
        this.asyncAxiosPost("monitoring_pppd_turunan/approval", "json", this.getAuth, {
          mon_pppd_balance_id: this.id,
          status: values.aksi,
          remark: values.catatan !== undefined ? values.catatan : ""
        })
        .then(() => {
          this.table.loading_submit = false;
          this.displayMessage("success");
          this.$router.go();
        })
        .catch((err) => {
          if (err.response.data.status === false) {
            this.displayMessage("wrong-password");
          }
          this.pageLoading = false;
        });
      });
    },
    validateMaxValue(e, maxValue){      
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
      if (allowedKeys.includes(e.key)) return;

      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
        return;
      }

      const currentRawValue = e.target.value.replace(/,/g, '');
      const predictedValue = Number(currentRawValue + e.key);

      if (predictedValue > maxValue) {
        e.preventDefault();
      }
    },
    toManifest(item){
      this.gotoManifestTrans(this, item, "_blank")
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 5px 5px ;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.result {
  margin: @padding 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center !important;
}

.tagsts{
  color: #1abc9c;
}

.ant-progress-outer {
  margin-right: calc(-2em - 5px)!important;
  padding-right: calc(2em + 5px)!important;
}

.bg_sum_directorat{
  // background-color: lighten(@color-secondary, 15);
  border-radius: 10px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2), 0 1px 4px rgba(0, 0, 0, 0.2), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
}

.bg_sum_trans{
  // background-color: lighten(@color-primary, 15);
  border-radius: 10px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2), 0 1px 4px rgba(0, 0, 0, 0.2), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
}

.w-full-currency-flex{
  flex: 1;
  margin-left: .5rem;
}

.ant-input-number-input{
  text-align: right!important;
}

.addpadd{
    padding: 5px !important;
}

.margin-small-right{
  margin-right: 5px !important;
}

.nopad{
  height: 100%!important;
  .ant-card-body{
    padding: 0px !important;
    height: 100%!important;
  }
}

.contentleft{
  .ant-collapse{
    .ant-collapse-item{
      .ant-collapse-header{
        padding: 10px!important;
        color: rgba(0, 0, 0, 0.65)!important;
        cursor: default;
      }
      .ant-collapse-content{
        .ant-collapse-content-box{
          padding: 5px;
        }
      }
    }
  }
  thead{
    tr{
      background-color: whitesmoke;
      th{
        font-weight: 700!important;
      }
    }
  }
  .ant-table-footer{
    background-color: whitesmoke!important;
  }
}

.table-resume{
  .indent-level-1{
    padding-left: 10px!important;
  }
  
  .ant-table-row{
      td:first-child{
        display: flex;
      }
  }
}

.cl_footer_man{
  &-2{
    background-color: whitesmoke!important;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 8px;
  }
  &-gt{
    padding: 0 8px 0 8px;
    &-2{
      padding: 0 8px 0 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  &-val{
    width: 100%;padding: 0 8px 0 8px;
  }
}

.tag-defaults{
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid rgb(217, 217, 217);
}

.ant-table-row.active-row td {
  background-color: lighten(@color-secondary, 50);
}
.ant-table-row.showPointer td {
  cursor: pointer;
}
</style>
